import React from "react";
import "./UpdateFieldSuccessAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import Recommened from "../../../../../../assets/Icons/Recommened";
import PenIconOutline from "../../../../../../assets/Icons/PenIconOutline";

export const UpdateFieldSuccessAICard = ({ message, onActionClick }) => {
  const now = new Date();
  const day = now.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = now.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  const fieldName = message.fieldName || "Activity ID";
  const newValue = message.newValue || "112850";
  const timestamp = message.updateTimestamp || "Dec 13, 2025 | 5:30 PM";

  return (
    <div className={`order-chat-bubble ${message.role}`}>
      <div className="order-ai-card update-field-success-card">
        <div className="order-ai-card-header">
          <div className="order-ai-card-title-logo">
            <img
              src={aiChatlogo}
              alt="LOGO"
              aria-hidden="true"
              className="order-ai-logo"
              style={{ width: 32, height: 32 }}
            />
          </div>
          <div className="order-ai-card-title-Avatar">
            <span>{message.header?.title || "Axon AI"}</span>
            <div className="order-ai-card-time">{`${day} ${time}`}</div>
          </div>
        </div>

        <div className="order-ai-card-body">
          <div className="update-field-success-container">
            <div className="success-message">
              {/* <span className="success-icon">✅</span> */}
              <span className="success-text">
                Field updated with {newValue} successfully. ✅
              </span>
            </div>

            <div className="success-question">
              <p>Do you want to update more fields?</p>
            </div>

            <div className="recommended-actions-section">
              <div className="recommended-actions-header">
                <span className="recommended-icon">
                  {/* 💡 */}
                  <Recommened />
                </span>
                <span className="recommended-title">Recommended Actions</span>
              </div>

              <div className="action-buttons">
                <button
                  className="action-btn"
                  onClick={() =>
                    onActionClick &&
                    onActionClick("I want to update multiple fields at once")
                  }
                >
                  Update more Fields
                </button>
                <button
                  className="action-btn"
                  onClick={() => onActionClick && onActionClick("Action Taken")}
                >
                  Action Taken
                </button>
                <button
                  className="action-btn"
                  onClick={() =>
                    onActionClick && onActionClick("Update Order Info")
                  }
                >
                  Add Order Info
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="update-footer-info">
          <span className="footer-icon">
            {/*📝*/}
            <PenIconOutline />
          </span>
          <div className="footer-text">
            <span> You have Updated {fieldName} value .</span>
            <span> {timestamp}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
